/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type TagProject_item$ref = any;
export type TagProjectModal_item$ref = any;
export type TagProjectModal_item = {
    readonly " $fragmentRefs": TagProject_item$ref;
    readonly " $refType": TagProjectModal_item$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "TagProjectModal_item",
    "type": "Item",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "TagProject_item",
            "args": null
        }
    ]
} as any);
(node as any).hash = 'de0c764ed665fd4532628048dc0a2ba2';
export default node;
